import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { AttachmentType } from '../enums/attachment-type.enum';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  private readonly apiService = inject(ApiService);

  upload(id: number,
    type: AttachmentType,
    file: File
  ): Observable<void> {
    return this.apiService.postFile(
      `${type}/${id}/attachments`,
      file
    );
  }

  download(attachmentId: number, type: AttachmentType): Observable<Blob> {
    return this.apiService.getBlob(
      `${type}/attachments/${attachmentId}`
    );
  }

  downloadByPath(path: string): Observable<Blob> {
    return this.apiService.getBlob(path);
  }

  delete(
    attachmentId: number, type: AttachmentType
  ): Observable<void> {
    return this.apiService.delete(
      `${type}/attachments/${attachmentId}`
    );
  }
}
